import { Colors } from "@constants";
import {
  BalanceScreens,
  PaymentsThunks,
  AccountThunks,
  ConfirmationPageActions,
  HomeScreens,
  POSScreens,
  OffersActions,
  PointOfSaleActions,
  TransactionsActions,
} from "@modules";
import { ForceInfoAppUpdateActions, GlobalState, LoaderActions } from "@redux";
import { NavigationProp } from "@react-navigation/native";
import React from "react";
import { ActivityIndicator } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { getDecodedId } from "@utils";

interface IProps {
  navigation: NavigationProp<any>;
}

export const MercanetLoadingScreen: React.FC<IProps> = React.memo(
  ({ navigation }) => {
    const dispatch = useDispatch();
    const accessToken = useSelector(
      (state: GlobalState) => state.auth.authToken?.accessToken
    );
    const userInfo = useSelector((state: GlobalState) => state.auth?.userInfo);
    const posId = useSelector(
      (state: GlobalState) => state.offers?.selectedOffer?.pos?.id
    );

    const searchURL = new URLSearchParams(window?.location?.search);
    const idRefill = searchURL.get("idRefill");
    const idOrder = searchURL.get("idOrder");

    console.log("current idRefill get from search url", idRefill);

    React.useEffect(() => {
      if (idRefill) {
        const idBank = searchURL.get("idBank");
        const statusPromise =
          idBank === "2"
            ? dispatch(PaymentsThunks.getAxeptaPaymentStatus(idRefill))
            : dispatch(
                PaymentsThunks.getPaymentSatus(idRefill, accessToken || "")
              );
        // @ts-ignore
        statusPromise.then(
          // @ts-ignore
					async ({
						// @ts-ignore
						refillSuccess,
            // @ts-ignore
						transactionSuccess,
            // @ts-ignore
						isNetworkError,
            // @ts-ignore
						userMessage,
            // @ts-ignore
            errorAction,
          }) => {
            let errorType = "refill.defaultTitle";
            let successMessage = null;

            if (idOrder && transactionSuccess) {
              const id = getDecodedId(idOrder) || idOrder;

              dispatch(OffersActions.setSelectedOfferSlot(null));
              dispatch(PointOfSaleActions.setNewOrder(true));

              dispatch(
                ConfirmationPageActions.setConfirmationPageParams({
                  id: id?.split(":")?.[1],
                  orderId: idOrder,
                  isFirstTime: true,
                  idPos: -1,
                  offerSlot: "",
                })
              );

              // todo - set the loading off
              //@ts-ignore
              navigation?.navigate(HomeScreens.POINT_OF_SALE_STACK, {
                screen: POSScreens.CONFIRMATION_PAGE,
              });
              return;
            }
            if (idOrder && !transactionSuccess) {
              dispatch(TransactionsActions.setRefillFromCart(false));
              // todo future - redirect user back to the cart
              /*const idPos = getDecodedId(posId);
                return navigation?.navigate(HomeScreens.POINT_OF_SALE_STACK, {
                  screen: POSScreens.RESTAURANT_DETAIL,
                  params: {
                    id: idPos?.split?.(":")?.[1],
                    isModify: false,
                    isRefillFromCart: true,
                  },
                });*/

              return navigation.navigate(BalanceScreens.ERROR_RECEIPT, {
                errorType: "refill.orderTitle",
                userMessage: userMessage ?? undefined,
                errorAction: errorAction ?? undefined,
              });
            }

            if (isNetworkError) {
              errorType = "refill.networkErrorTitle";
            } else if (transactionSuccess === false) {
              errorType = "refill.failTitle";
            } else if (transactionSuccess === null) {
              // this case should never produce
            } else if (refillSuccess) {
              successMessage = "refill.successTitle";
            } else if (refillSuccess === false || refillSuccess === null) {
              successMessage = "refill.delayTitle";
            }

            if (successMessage) {
              dispatch(LoaderActions.setLoading(true));
              // @ts-ignore
              await dispatch(
                AccountThunks.getBalance({
                  id: userInfo?.id || "",
                })
              );
              dispatch(ForceInfoAppUpdateActions.setForceAppUpdate(true));
              dispatch(LoaderActions.setLoading(false));
              navigation.navigate(BalanceScreens.SUCCEED_REFILL_SCREEN, {
                successMessage,
              });
              return;
            }

            return navigation.navigate(BalanceScreens.ERROR_RECEIPT, {
              errorType,
              userMessage: userMessage ?? undefined,
              errorAction: errorAction ?? undefined,
            });
          }
        );
      }
    }, []);

    return (
      <ActivityIndicator
        size="large"
        color={Colors.black}
        style={{ height: "100vh" }}
      />
    );
  }
);
